import React from 'react';
import { NotificationCategoryNames } from '../../types/notification_deliveries';
import classNames from 'classnames';
import './notificationCategoryTag.module.scss';

export type Props = {
  categoryTagColor: 'red' | 'gray';
  categoryName: NotificationCategoryNames;
};

export const NotificationCategoryTag = ({ categoryTagColor, categoryName }: Props) => {
  return (
    <div
      styleName={classNames('notification-category', categoryTagColor)}
      data-value="notification-category"
      data-color={categoryTagColor}
    >
      {categoryName}
    </div>
  );
};
